export function deriveCRUDNames(baseName) {
  return {
    actionSuccess: baseName.toUpperCase() + "S_READ_SUCCESS",
    actionFailure: baseName.toUpperCase() + "S_READ_FAILURE",
    stateKey: baseName + "s",
    getFuncName: "get" + baseName.charAt(0).toUpperCase() + baseName.slice(1) + "s",
  };
}



// WEBPACK FOOTER //
// ./src/components/NewDashboard/crudHelpers.js